import { render, staticRenderFns } from "./GlobalVisionProfitabilitySummaryFormulaComponent.vue?vue&type=template&id=0e0ed352&scoped=true"
import script from "./GlobalVisionProfitabilitySummaryFormulaComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./GlobalVisionProfitabilitySummaryFormulaComponent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./GlobalVisionProfitabilitySummaryFormulaComponent.vue?vue&type=style&index=0&id=0e0ed352&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0ed352",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e0ed352')) {
      api.createRecord('0e0ed352', component.options)
    } else {
      api.reload('0e0ed352', component.options)
    }
    module.hot.accept("./GlobalVisionProfitabilitySummaryFormulaComponent.vue?vue&type=template&id=0e0ed352&scoped=true", function () {
      api.rerender('0e0ed352', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dialog/customDialogs/globalVisionProfitability/GlobalVisionProfitabilitySummaryFormulaComponent.vue"
export default component.exports